import React from 'react';
import { Button, Typography, Modal, ModalBody, } from '@one-thd/sui-atomic-components';
import { LazyImage } from '../../../../../shared/LazyImage';
import { SimpleCarousel } from '../../SimpleCarousel/SimpleCarousel';
import { assetsPricing, pbPreferredPricing, } from '../../../../../../constants/PricingBenefits';
import { VideoLabelBtn, VideoLabelPlayBtn, VideoContainer, ModalCloseIcon, Img, VideoPP, } from './Shared';
import { clickCta, setOverlayEvent } from '../../../../../../utils/analytics';
var constants = pbPreferredPricing.PrefPricingBanner;
var VIDEO_ID = 5;
var pgnClass = {
    // Pagination classes (Overrides _pagination.scss from global-css repo)
    active: ' sui-cursor-pointer sui-bg-brand sui-text-inverse sui-font-w-bold',
    activeLeft: ' sui-rounded-l-full',
    activeRight: ' sui-rounded-r-full',
    'hd-pagination__desktop-modal': 'sui-h-56 sui-leading-tight sui-mb-4 sm:sui-mb-0',
    'hd-pagination__wrapper': 'hd-pagination__wrapper !sui-my-4 !sui-mx-auto sui-list-none',
    'hd-pagination__link': 'hd-pagination__link !sui-text-lg !sui-py-[5px] !sui-px-[15px] !bg-[length:40%]',
    'hd-pagination__item1': 'sui-m-0 sui-float-left',
};
// For HowItWorks Modal
export var HowItWorksModal = function (_a) {
    var isMobile = _a.isMobile;
    var _b = React.useState(false), toggle = _b[0], setToggle = _b[1];
    var filterData = React.useState(pbPreferredPricing.modallist)[0];
    var _c = React.useState(false), play = _c[0], setPlay = _c[1];
    var handleVideo = function () {
        return setPlay(!play);
    };
    var ModalImages = function (_a) {
        var data = _a.data;
        var id = data.id, imgurl = data.imgurl;
        return (React.createElement("div", null, id === VIDEO_ID ? (React.createElement(VideoLabelPlayBtn, { rounded: true, setModal: handleVideo })) : (React.createElement(LazyImage, { src: imgurl, classes: "", altText: "Top banner, Home Depot store", "aria-label": "image" }))));
    };
    var RenderDesktopNavigation = function (navProps) {
        var currentIndex = navProps.currentIndex, onHandleClick = navProps.onHandleClick;
        var activeTab = function (props1) {
            var border;
            if (props1.id === currentIndex + 1) {
                if (currentIndex === 0) {
                    border = "".concat(pgnClass.active, " ").concat(pgnClass.activeLeft);
                }
                else if (currentIndex === filterData.length - 1) {
                    border = "".concat(pgnClass.active, " ").concat(pgnClass.activeRight);
                }
                else {
                    border = pgnClass.active;
                }
            }
            else {
                border = '';
            }
            return border;
        };
        var handleLeftClick = function () {
            if (currentIndex > 0) {
                var currentDataNavigation = currentIndex - 1;
                onHandleClick(currentDataNavigation);
            }
        };
        var handleRightClick = function () {
            if (currentIndex < filterData.length - 1) {
                var currentDataNavigation = currentIndex + 1;
                onHandleClick(currentDataNavigation);
            }
        };
        return (React.createElement("div", { className: "sui-text-center" },
            React.createElement("ul", { className: pgnClass['hd-pagination__wrapper'] },
                React.createElement("li", { "data-testid": "hd-pagination__item1", className: currentIndex === 0
                        ? "hd-pagination__button ".concat(pgnClass['hd-pagination__item1'])
                        : ' hd-pagination__button hd-pagination__item' },
                    React.createElement("button", { type: "button", onClick: handleLeftClick, "aria-label": "button", className: "".concat(currentIndex > 0
                            ? pgnClass['hd-pagination__link']
                            : 'sui-hidden') }, "\u00A0")),
                filterData.map(function (test) { return (React.createElement("li", { key: test.id, className: "hd-pagination__item ".concat(activeTab(test)) },
                    React.createElement("button", { type: "button", "aria-label": "button", onClick: function () {
                            var newValue = test.id - 1;
                            onHandleClick(newValue);
                        }, className: pgnClass['hd-pagination__link'] }, test.id))); }),
                React.createElement("li", { className: "hd-pagination__item hd-pagination__button" },
                    React.createElement("button", { type: "button", "aria-label": "button", onClick: handleRightClick, className: "".concat(currentIndex < filterData.length - 1
                            ? pgnClass['hd-pagination__link']
                            : 'sui-hidden') }, "\u00A0")))));
    };
    var RenderModalPagination = function () {
        var _a, _b;
        var _c = React.useState(0), currentDataIndex = _c[0], setCurrentDataIndex = _c[1];
        var currentDataSelected = filterData[currentDataIndex];
        var id = currentDataSelected.id, name = currentDataSelected.name, imgurl = currentDataSelected.imgurl, description = currentDataSelected.description;
        var handleClick = React.useCallback(function (index) {
            setCurrentDataIndex(index);
            // analytics.pushMyAccountButtonEvent(
            //   `pricing: pro xtra preferred pricing: how does it work overlay: swipe`,
            // );
        }, [currentDataIndex]);
        var nameMaxWidth = {
            '1': { name: '190px', desc: '' },
            '2': { name: '220px', desc: '' },
            '3': { name: '', desc: '' },
            '4': { name: '', desc: '' },
            '5': { name: '', desc: '' },
        };
        return (React.createElement("div", { className: "sui-h-full sui-text-base sui-px-6 sui-flex sui-flex-col" },
            React.createElement("div", { className: "sui-py-4" }, pbPreferredPricing.modalEasyTitle),
            React.createElement("div", { className: "sui-grow" },
                React.createElement("div", { "data-testid": "hd-pagination__desktop-modal", className: "sui-grid sui-grid-cols-12 ".concat(pgnClass['hd-pagination__desktop-modal']) },
                    React.createElement("div", { className: "sui-col-span-5 sui-flex sui-flex-col" },
                        React.createElement("div", { className: "sui-text-xl sui-pt-5 sui-font-bold sui-pb-4" },
                            React.createElement("p", { style: { maxWidth: ((_a = nameMaxWidth["".concat(id)]) === null || _a === void 0 ? void 0 : _a.name) || 'none' } }, name)),
                        React.createElement("div", { className: "sui-pb-6" },
                            React.createElement("p", { style: { maxWidth: ((_b = nameMaxWidth["".concat(id)]) === null || _b === void 0 ? void 0 : _b.desc) || 'none' } }, description)),
                        id === VIDEO_ID && !play && (React.createElement("button", { type: "button", className: "sui-block sui-invisible", onClick: handleVideo },
                            pbPreferredPricing.watchButton,
                            ' ',
                            React.createElement("span", { className: "" },
                                React.createElement("img", { src: assetsPricing.NextArrow, width: "auto", height: "auto", alt: "img" }))))),
                    React.createElement("div", { className: "sui-col-span-1" }, "\u00A0"),
                    React.createElement("div", { className: "sui-col-span-6 sui-flex sui-justify-center sui-flex-col" },
                        React.createElement(ModalImages, { data: currentDataSelected })))),
            React.createElement("div", null,
                React.createElement(RenderDesktopNavigation, { onHandleClick: handleClick, currentIndex: currentDataIndex }))));
    };
    var StepContentDT = function (_a) {
        var classes = _a.classes;
        return (React.createElement("div", { "data-testid": "modal-container-dt", className: classes !== null && classes !== void 0 ? classes : 'sui-flex sui-flex-col sui-absolute sui-left-0 sui-right-0 sui-top-0 sui-bottom-0 sui-justify-between' },
            React.createElement("div", { className: "sui-grow sui-flex sui-flex-col" },
                React.createElement("div", { className: "sui-grid sui-grid-cols-12 sui-text-3xl sui-py-4 sui-px-6 sui-border-solid sui-border-b-1 sui-border-primary" },
                    React.createElement("div", { className: "sui-col-span-11" }, pbPreferredPricing.modalHowItWork),
                    React.createElement("div", { className: "sui-col-span-1 sui-flex sui-justify-end" },
                        React.createElement(ModalCloseIcon, { setModal: setToggle }))),
                React.createElement("div", { className: "sui-grow" },
                    React.createElement(RenderModalPagination, null))),
            React.createElement("div", { className: "sui-px-6 sui-border-solid sui-border-t-1 sui-border-primary sui-py-4 sui-text-right" },
                React.createElement(Button, { variant: "primary", "aria-label": "button", classes: "sui-bg-brand sui-h-11", onClick: function () { return setToggle(false); } }, "Got It!"))));
    };
    var ModalDT = function () { return (React.createElement(Modal, { open: toggle, size: "md", onClose: function () { return setToggle(false); } },
        React.createElement(ModalBody, null,
            React.createElement("div", { className: "sui-h-full" }, !play ? (React.createElement(React.Fragment, null,
                React.createElement(StepContentDT, null),
                React.createElement(StepContentDT, { classes: "sui-invisible" }))) : (React.createElement(React.Fragment, null,
                React.createElement("div", { "data-testid": "video-container-dt", className: "sui-h-full sui-bg-inverse sui-pt-7 sui-absolute sui-left-0 sui-right-0 sui-top-0 sui-bottom-0" },
                    React.createElement(VideoContainer, { setModal: function () {
                            handleVideo();
                        } })),
                React.createElement("div", { className: "sui-invisible" },
                    React.createElement(VideoContainer, { setModal: function () {
                            handleVideo();
                        }, noAutoPlay: true })))))))); };
    var ModalDesktop = function () {
        var ButtonDT = function () { return (React.createElement("div", { className: "sui-flex" },
            React.createElement("span", null, constants.qualified.content1),
            React.createElement("button", { type: "button", "aria-label": "button", className: "sui-cursor-pointer", onClick: function () {
                    setToggle(true);
                    setOverlayEvent('pricing benefits preferred pricing how does it work');
                } },
                React.createElement("span", { className: "sui-pl-3 sui-pr-2" }, constants.qualified.content2),
                React.createElement("span", { className: "" },
                    React.createElement("img", { src: assetsPricing.NextArrow, className: "sui-h-3 sui-align-baseline", width: "auto", height: "auto", alt: "img" }))))); };
        return (React.createElement(React.Fragment, null,
            React.createElement(ModalDT, null),
            React.createElement(ButtonDT, null)));
    };
    var ModalMobile = function () {
        var PaintBenefitsCard = function (mobilelist) {
            var _a, _b;
            var id = mobilelist.id, name = mobilelist.name, imgurl = mobilelist.imgurl, description = mobilelist.description;
            var nameMaxWidth = {
                '1': { name: '', desc: '270px' },
                '2': { name: '250px', desc: '' },
                '3': { name: '200px', desc: '' },
                '4': { name: '', desc: '' },
                '5': { name: '', desc: '250px' },
            };
            return (React.createElement("div", { className: "" },
                React.createElement("div", { className: "sui-grid sui-grid-cols-12 sui-font-bold sui-text-lg sui-mb-5" },
                    React.createElement("div", { className: "sui-col-span-1" }),
                    React.createElement("div", { className: "sui-col-span-10 sui-flex sui-justify-center" },
                        React.createElement("p", { style: { maxWidth: ((_a = nameMaxWidth["".concat(id)]) === null || _a === void 0 ? void 0 : _a.name) || 'none' } }, name))),
                React.createElement("div", { className: "sui-flex sui-flex-col sui-justify-center", style: { height: '160px' } }, id === VIDEO_ID && !play ? (React.createElement("div", { className: "sui-grid sui-grid-cols-12" },
                    React.createElement("div", { className: "sui-col-span-1" }),
                    React.createElement("div", { className: "sui-col-span-10" },
                        React.createElement(VideoLabelPlayBtn, { rounded: true, isDark: true, setModal: handleVideo })))) : (React.createElement(LazyImage, { src: imgurl, width: "210", height: "155", classes: "", "aria-label": "image", altText: "Top banner, Home Depot store" }))),
                React.createElement("div", { className: "sui-grid sui-grid-cols-12 sui-mt-5 sui-pt-2" },
                    React.createElement("div", { className: "sui-col-span-1" }),
                    React.createElement("div", { className: "sui-col-span-10 sui-flex sui-justify-center" },
                        React.createElement("p", { style: { maxWidth: ((_b = nameMaxWidth["".concat(id)]) === null || _b === void 0 ? void 0 : _b.desc) || 'none' } }, description)))));
        };
        var ButtonMW = function () {
            var BannerText = function () { return (React.createElement(React.Fragment, null,
                React.createElement(Typography, { variant: "h3", weight: "display", color: "inverse" }, constants.qualified.content1),
                React.createElement("p", { className: "sui-mt-2" },
                    constants.qualified.content2,
                    React.createElement(Img, { classes: "sui-h-3 sui-pl-2 sui-mb-1", src: assetsPricing.NextArrowOrange })))); };
            var BannerContainer = function (_a) {
                var children = _a.children;
                return (React.createElement("button", { type: "button", className: "sui-cursor-pointer sui-w-full", "aria-label": "button", onClick: function () {
                        setToggle(true);
                        clickCta('pricing benefits preferred pricing how does it work');
                    } }, children));
            };
            return (React.createElement(BannerContainer, null,
                React.createElement("div", { className: "sui-relative sui-text-inverse sui-mt-2", "data-testid": "TierQualifiedMobile__Banner" },
                    React.createElement(Img, { src: assetsPricing.bgBrownGradient, classes: "sui-w-full" }),
                    React.createElement("div", { className: "sui-absolute sui-top-0 sui-right-0 sui-left-0 sui-bottom-0" },
                        React.createElement("div", { className: "sui-relative sui-h-full" },
                            React.createElement("div", { className: "sui-w-[49%] sui-h-full sui-absolute sui-right-0 sui-overflow-hidden sui-text-right sui-rounded-r-lg" },
                                React.createElement(Img, { src: assetsPricing.photoVirtualIdScan, classes: "sui-h-full sui--ml-1" })),
                            React.createElement("div", { className: "sui-absolute sui-top-0 sui-h-full sui-flex sui-flex-col sui-justify-center sui-pl-5 sui-text-left", "data-testid": "pb-PreferredPricing__TierQualifiedMobile__BannerText" },
                                React.createElement(BannerText, null)))))));
        };
        var ModalMW = function () {
            var Header = function (_a) {
                var isInvisible = _a.isInvisible;
                return (React.createElement("div", { className: "sui-border-b-1 sui-border-primary sui-shadow-sm sui-p-3 sui-bg-primary sui-top-0 sui-right-0 sui-left-0 sui-z-10\n          ".concat(isInvisible ? 'sui-invisible' : 'sui-fixed'), "data-testid": "modal__mobileHeader" },
                    React.createElement("div", { className: "sui-grid sui-grid-cols-12" },
                        React.createElement("div", { className: "sui-col-span-10 sui-font-bold sui-text-lg" }, "How Does It Work?"),
                        React.createElement("div", { className: "sui-col-span-2 sui-text-right" },
                            React.createElement(ModalCloseIcon, { setModal: !isInvisible ? setToggle : undefined })))));
            };
            var Footer = function (_a) {
                var isInvisible = _a.isInvisible;
                return (React.createElement("div", { className: "sui-p-3 sui-border-solid sui-border-t-1 sui-border-primary sui-shadow-sm\n          sui-bottom-0 sui-right-0 sui-left-0 sui-bg-primary sui-z-10\n          ".concat(isInvisible ? 'sui-invisible' : 'sui-fixed'), "data-testid": "modalFooter" },
                    React.createElement(Button, { variant: "primary", classes: "sui-bg-brand", "aria-label": "button", onClick: !isInvisible ? function () { return setToggle(false); } : undefined }, "Got It!")));
            };
            var TopHero = function () { return (React.createElement("div", { className: "sui-pt-5" },
                React.createElement("div", { className: "sui-pb-4 sui-relative sui-mb-5 sui-mt-1" },
                    React.createElement("div", { className: "" },
                        React.createElement("div", { className: "sui-grid sui-grid-cols-12" },
                            React.createElement("div", { className: "sui-col-span-2" }),
                            React.createElement("div", { className: "sui-col-span-8 sui-border-solid sui-border-primary sui-border-b-1 sui-border-strong" }, "\u00A0"))),
                    React.createElement("div", { className: "sui-absolute sui-top-0 sui-right-0 sui-left-0" },
                        React.createElement(LazyImage, { src: assetsPricing.dollarLogo, width: "52", height: "52", classes: "", altText: "Top banner, Home Depot store", "aria-label": "image" }))),
                React.createElement("div", null, pbPreferredPricing.modalEasyTitle))); };
            return (React.createElement(Modal, { open: toggle, size: "lg", onClose: function () { return setToggle(false); } },
                React.createElement(ModalBody, null,
                    React.createElement("div", { className: "sui-h-full" }, !play ? (React.createElement("div", { "data-testid": "modal-container-mw", className: "sui-relative sui-h-full sui-text-base" },
                        React.createElement(Header, null),
                        React.createElement("div", { className: "sui-h-full sui-text-center sui-flex sui-flex-col sui-justify-between" },
                            React.createElement(Header, { isInvisible: true }),
                            React.createElement(TopHero, null),
                            React.createElement("div", { className: "sui-pt-4 sui-pb-6 sui-h-full" },
                                React.createElement(SimpleCarousel, { showIndicators: true, items: filterData, render: PaintBenefitsCard, analyticsCall: true, analyticsText: "pricing: pro xtra preferred pricing: how does it work overlay: swipe" })),
                            React.createElement(Footer, { isInvisible: true })),
                        React.createElement(Footer, null))) : (React.createElement("div", { "data-testid": "video-container-mw", className: "sui-h-full sui-bg-inverse sui-absolute sui-left-0 sui-right-0 sui-top-0 sui-bottom-0" },
                        React.createElement(VideoContainer, { setModal: function () {
                                handleVideo();
                            } })))))));
        };
        return (React.createElement(React.Fragment, null,
            isMobile ? React.createElement(ModalMW, null) : React.createElement(ModalDT, null),
            React.createElement(ButtonMW, null)));
    };
    return isMobile ? React.createElement(ModalMobile, null) : React.createElement(ModalDesktop, null);
};
// For Video Modal file
export var VideoModal = function (_a) {
    var isMobile = _a.isMobile, rounded = _a.rounded, children = _a.children;
    var _b = React.useState(false), modal = _b[0], setModal = _b[1];
    var handleClose = function () { return setModal(false); };
    var InvisibleVideo = function () { return (React.createElement("div", { className: "sui-invisible sui-flex sui-p-6 sui-h-full" },
        React.createElement("div", { className: "sui-pb-3 sui-absolute sui-right-6 sui-top-4" },
            React.createElement(ModalCloseIcon, { setModal: setModal })),
        React.createElement(VideoPP, { noAutoPlay: true }))); };
    var ModalDesktop = function () {
        // Gray X hovers over video
        return (React.createElement("div", { className: "sui-relative" },
            React.createElement(Modal, { open: modal, size: isMobile ? 'lg' : 'md', onClose: handleClose },
                React.createElement(ModalBody, null,
                    React.createElement("div", { className: "sui-h-full" },
                        React.createElement("div", { "data-testid": "video-container", className: "sui-h-full sui-flex sui-justify-center sui-bg-inverse\n                sm:sui-px-6 sm:sui-pb-6 sui-absolute sui-pt-12 sui-left-0 sui-right-0 sui-bottom-0" },
                            React.createElement("div", { className: "sui-pb-3 sui-absolute sui-right-3 sm:sui-right-6 sui-top-4\n                  sui-z-10" },
                                React.createElement(ModalCloseIcon, { setModal: setModal })),
                            React.createElement(VideoPP, null),
                            React.createElement("div", null)),
                        React.createElement(InvisibleVideo, null))))));
    };
    var DefaultButton = function () {
        return (React.createElement("button", { type: "button", className: "sui-w-full", "data-testid": "videoLogo", "aria-label": "button", onClick: function () {
                setModal(true);
                clickCta('pricing benefits: member video view');
            } },
            React.createElement(VideoLabelBtn, { rounded: rounded })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalDesktop, null),
        children ? { children: children } : React.createElement(DefaultButton, null)));
};
